import { faEdit, faTools, faTractor, faUserCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CompareArrows from "@material-ui/icons/CompareArrows";
import Folder from "@material-ui/icons/Folder";
import HomeIcon from "@material-ui/icons/Home";
import Settings from "@material-ui/icons/Settings";
import Tune from "@material-ui/icons/Tune";
import React from "react";
import {getUserProfile} from "./../modules/user/redux/action"

const home = {
  name: <span onClick={()=>getUserProfile(JSON.parse(localStorage.getItem('user')),JSON.parse(localStorage.getItem("userProfile")).username)}>Home</span>,
  icon: <HomeIcon />,
  link: "/app",
  margin: "25px"
};
const reports = {
  name: "Reports",
  icon: <Folder />,
  link: "/reports"
};
const riskManagement = {
  name: "Risk Management",
  icon: <CompareArrows />,
  link: "/riskmanagement"
};
const farmManagement = {
  name: "Farm Management",
  icon: <FontAwesomeIcon icon={faTractor} style={{ fontSize: "20px" }} />,
  link: "/farmmanagement"
};
const userManagement = {
  name: "User Management",
  icon: <FontAwesomeIcon icon={faUserCog} style={{ fontSize: "20px" }} />,
  link: "/usermanagement"
};
const reconciliation = {
  name: "Reconciliation",
  icon: <FontAwesomeIcon icon={faEdit} style={{ fontSize: "20px" }} />,
  link: "/reconciliation"
};
const connectionManagement = {
  name: "Connections",
  icon: <FontAwesomeIcon icon={faUserCog} style={{ fontSize: "20px" }} />,
  link: "/connection-management"
}
const farmSetUp = {
  name: "Farm set up",
  icon: <Tune />,
  link: "/farmsetup"
};
const settings = {
  name: "Settings",
  icon: <Settings />,
  link: "/settings"
};
const farmUtilities = {
  name: "Farm Utilities",
  icon: <FontAwesomeIcon icon={faTools} style={{ fontSize: "24px" }} />,
  link: "/farm-utilities"
};
const changePassword = {
  name: "Change Password",
  icon: <FontAwesomeIcon icon={faTools} style={{ fontSize: "24px" }} />,
  link: "/changepassword"
};
const basicPlan = [
  home,
  reports,
  riskManagement,
  reconciliation,
  farmSetUp,
  settings,
  farmUtilities
];
const basicPlusPlan = [
  home,
  reports,
  riskManagement,
  reconciliation,
  farmSetUp,
  settings,
  farmUtilities
];
const enterprisePlan = [
  home,
  reports,
  riskManagement,
  reconciliation,
  farmSetUp,
  settings,
  farmUtilities
];
const enterprisePlusPlan = [
  home,
  reports,
  riskManagement,
  reconciliation,
  farmSetUp,
  settings,
  farmUtilities
];
const superAdminPlan = [
  home,
  reports,
  riskManagement,
  reconciliation,
  farmSetUp,
  farmManagement,
  userManagement,
  settings,
  changePassword
];
const CounterpartyNavbar = [
  home,
  reports,
  reconciliation,
  connectionManagement,
  // settings,
];

const farmEmployeeList = [home, farmSetUp];

const NavList = {
  SUPER_ADMIN: {
    0: superAdminPlan
  },
  ACCOUNT_OWNER: {
    1: basicPlan,
    2: basicPlusPlan,
    3: enterprisePlan,
    4: enterprisePlusPlan
  },
  ACCOUNT_ADMIN: {
    1: basicPlan,
    2: basicPlusPlan,
    3: enterprisePlan,
    4: enterprisePlusPlan,
  },
  FARM_EMPLOYEE: {
    1: farmEmployeeList,
    2: farmEmployeeList,
    3: farmEmployeeList,
    4: farmEmployeeList
  },
  COUNTER_PARTY: {
    0: CounterpartyNavbar
  },
};

export default NavList;




// WEBPACK FOOTER //
// ./src/constants/NavList.js